export default __webpack_public_path__ + "static/media/Ilanit Eliaz.47f625d7.jpg";